<template>
  <div class="">
    <div class="section-box">
      <div class="das-form-container">
        <div class="das-form-group">
          <span>{{ datetimeDisplay }}</span>
          <InfoList
            style="padding-top: 10px"
            class="das-form-container"
            :columns="4"
            :column-breakpoint-options="{
              sm: 2,
              md: 2
            }"
          >
            <InfoListLabel>
              <div class="label">Thu ngân</div>
            </InfoListLabel>
            <InfoListInput class="das-form-input">
              <div>
                {{ workShiftInfo?.username }}
              </div>
            </InfoListInput>

            <InfoListLabel>
              <div class="label">Quầy</div>
            </InfoListLabel>
            <InfoListInput class="das-form-input">
              <div>{{ workShiftInfo?.ticket_office_name }}</div>
            </InfoListInput>

            <InfoListLabel>
              <div class="label das-label">Kế toán nhận</div>
            </InfoListLabel>
            <InfoListInput class="das-form-input">
              <div>{{ 'Bùi Kim Thanh' }}</div>
            </InfoListInput>
          </InfoList>
        </div>
      </div>
    </div>

    <div v-loading="loading" class="mt-10">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :pinned-bottom-row-data="pinnedBottomRow"
        :context="context"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import RightPanel from '@/components/RightPanel'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { component as VueNumber } from '@coders-tm/vue-number-format'

import { getAllHotel } from '@/api/hotel'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import {
  getHistoryBreakfast,
  setHistoryBreakfast
} from '@/api/business_area_service/breakfastReal'
import { getWorkShiftInfoApi } from '@/api/cashier_service/closeShiftWork.js'
import CellRendererNumberDisplay from '@/views/mci/closeShiftWork/components/cellRendererNumberDisplay.vue'
import CellRenderCurrencyInput from '@/views/mci/closeShiftWork/components/CellRenderCurrencyInput.vue'
import CellRenderTextInput from '@/views/mci/closeShiftWork/components/CellRenderTextInput.vue'
import Vue from 'vue'

export default {
  components: {
    Breadcrumb,
    RightPanel,
    SelectWithSearchTable,
    VueNumber,
    CalendarSelect,
    CellRenderTextInput: CellRenderTextInput,
    // CellRenderNoteInput,
    CellRendererNumberDisplay: CellRendererNumberDisplay,
    CellRenderCurrencyInput: CellRenderCurrencyInput
  },
  props: {
    workShiftInfo: {
      type: Object
    }
  },
  data() {
    return {
      cashListReportDialog: false,
      loading: false,
      listAssign: [],

      // workShiftInfo: null,
      datetime: this.$moment(),

      context: null,
      columns: [
        {
          headerName: 'STT',
          field: 'no',
          maxWidth: 80
          //     cellRendererParams: () => {
          //   return {
          //     type: 'number'
          //   }
          // }
        },
        {
          headerName: 'Mệnh giá(VNĐ)',
          field: 'denomination',
          cellDataType: false,
          maxWidth: 190,
          // cellClass: 'grid-cell-right',
          cellRendererSelector: params => {
            console.log('check params', params)
            if (params.node.rowPinned === 'bottom') {
              return params.value
            }
            if (params.data.no > 10) {
              return {
                component: 'CellRenderTextInput',
                params: {
                  colName: params.column.colId,
                  align: 'align-left',
                  max: 50
                }
              }
            } else {
              return {
                component: 'CellRendererNumberDisplay',
                params: { colName: params.column.colId }
              }
              // return params.value
            }
          }
        },
        {
          headerName: 'Số lượng',
          field: 'quantity',
          cellDataType: false,
          // cellRenderer: CellRenderTextInput,
          minWidth: 150,
          maxWidth: 200,
          cellRendererSelector: params => {
            if (params.node.rowPinned === 'bottom') {
              return {
                component: 'CellRendererNumberDisplay',
                params: { colName: params.column.colId }
              }
            }

            if (params.data.no <= 10) {
              return {
                component: 'CellRenderCurrencyInput',
                params: {
                  colName: params.column.colId,
                  textAlign: 'align-left'
                }
              }
            } else {
              return {
                component: 'CellRenderTextInput',
                params: {
                  colName: params.column.colId,
                  align: 'align-left',
                  max: 50
                }
              }
            }
          }
        },
        {
          headerName: 'Thành tiền',
          field: 'total',
          cellDataType: false,
          cellClass: 'grid-cell-right',
          cellRendererSelector: params => {
            if (params.node.rowPinned === 'bottom') {
              return {
                component: 'CellRendererNumberDisplay',
                params: { colName: params.column.colId }
              }
            }

            if (params.data.no > 10) {
              return {
                component: 'CellRenderTextInput',
                params: {
                  colName: params.column.colId,
                  align: 'align-left',
                  max: 50
                }
              }
            } else {
              return {
                component: 'CellRendererNumberDisplay',
                params: { colName: params.column.colId }
              }
              // return params.value
            }
          }
        },
        {
          headerName: 'Ghi chú(50 Kí tự)',
          field: 'note',
          minWidth: 220,
          cellRendererSelector: params => {
            if (params.node.rowPinned === 'bottom') {
              return {
                component: ''
              }
            } else {
              return {
                component: 'CellRenderTextInput',
                params: {
                  colName: params.column.colId,
                  align: 'align-left',
                  max: 50
                }
              }
              // return params.value
            }
          }
          // cellRendererParams: (params) => {
          //   return {
          //     colName: params.column.colId,
          //     type: 'text'
          //   }
          // }
        }
      ],
      rows: [
        {
          no: 1,
          denomination: 500000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 2,
          denomination: 200000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 3,
          denomination: 100000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 4,
          denomination: 50000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 5,
          denomination: 20000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 6,
          denomination: 10000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 7,
          denomination: 5000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 8,
          denomination: 2000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 9,
          denomination: 1000,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 10,
          denomination: 500,
          quantity: 0,
          total: 0,
          type: 1,
          note: ''
        },
        {
          no: 11,
          denomination: '',
          quantity: '',
          total: '',
          type: 0,
          note: ''
        },
        {
          no: 12,
          denomination: '',
          quantity: '',
          total: '',
          type: 0,
          note: ''
        },
        {
          no: 13,
          denomination: '',
          quantity: '',
          total: '',
          type: 0,
          note: ''
        }
      ],
      pinnedBottomRow: [
        {
          no: null,
          denomination: 'Tổng cộng',
          quantity: 0,
          total: 0,
          note: ''
        }
      ]
    }
  },
  computed: {
    datetimeDisplay() {
      return `Ngày ${this.datetime.date()} tháng ${
        this.datetime.month() + 1
      } năm ${this.datetime.year()}, ${this.datetime.hour()} giờ ${this.datetime.minute()} phút`
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    this.getInfoShiftWork()
  },
  methods: {
    updateCurrentDatetime() {
      this.datetime = this.$moment()
    },
    openCashListReport() {
      this.cashListReportDialog = true
    },
    onResetSearchParams() {
      this.searchParams.date = this.$moment(new Date()).format('YYYY-MM-DD')
      this.getInfoShiftWork()
    },

    changeCurrencyInput(params, value, colNm) {
      console.log(params, value, colNm)
      const gridApi = this.$refs.agGrid.gridApi
      const rowIdx = params.rowIndex
      if (isNaN(value)) this.rows[rowIdx][colNm] = null
      this.rows[rowIdx][colNm] = value
      if (!isNaN(value)) {
        this.rows[rowIdx]['total'] = value * this.rows[rowIdx]['denomination']
        // console.log(agGrid.value)
      } else {
        this.rows[rowIdx]['total'] = 0
      }
      gridApi.forEachNode(node => {
        {
          if (node.data.no === params.data.no) node.setData(node.data)
        }
      })
      let pinnedTopRowDataTemp = [
        {
          no: null,
          denomination: 'Tổng cộng',
          quantity: 0,
          total: 0,
          note: ''
        }
      ]
      for (var i = 0; i < 10; i++) {
        pinnedTopRowDataTemp[0].quantity += !isNaN(this.rows[i].quantity)
          ? this.rows[i].quantity
          : 0
        pinnedTopRowDataTemp[0].total += this.rows[i].total
      }
      this.pinnedBottomRow = pinnedTopRowDataTemp
    },

    textInputChange(params, value, colName) {
      const rowIdx = params.rowIndex
      this.rows[rowIdx][colName] = value
    }
  }
}
</script>

<style lang="scss" scoped>
.button-containers {
  position: fixed;
  bottom: 30px;
  right: 20px;
}
.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
